import { ChartPiece, ChartPieModel } from "model/chart/ChartPieModel";
import { VictoryLabel, VictoryPie, VictoryTheme } from "victory";

type Props = {
    dados: ChartPieModel;
}

export default function DocumentoChartPie(props: Props) {

    const colors = [
        "#284703",
        "#CC8F00",
        "#7B0009",
    ];

    return <div style={{ display: "flex", height: "100%", flexDirection: "column", columnGap: 24, alignItems: "center" }}>
        <div style={{ height: "100%", aspectRatio: "1 / 1" }}>
            <svg viewBox="0 0 400 400">
                <VictoryPie
                    colorScale={colors}
                    width={400}
                    height={400}
                    standalone={false}
                    theme={VictoryTheme.material}
                    data={props.dados.pieces.map((dado: ChartPiece) => ({
                        ...dado,
                        x: dado.name,
                        y: dado?.value || 0
                    }))}
                    labelRadius={100}
                    labels={({ datum }) => datum.y > 0 ? datum.y : ''}
                    labelComponent={
                        <VictoryLabel
                            style={[
                                { fill: '#FFF', fontFamily: "arial", fontSize: 24, fontWeight: 'bold', textAnchor: 'middle' }
                            ]}
                        />
                    }
                />
            </svg>
        </div>
        <div style={{ boxSizing: "border-box", flex: 1, display: "flex", justifyContent: "space-between", rowGap: 10, paddingRight: 20, paddingLeft: 20, width: "100%" }}>
            {props.dados.pieces.map((item, index) => (
                <div style={{ display: "flex", alignItems: "center", columnGap: 10 }}>
                    <div style={{ minWidth: 20, minHeight: 20, backgroundColor: colors[index], borderRadius: 10 }}></div>
                    <span style={{ textOverflow: "ellipsis", overflow: "hidden", fontWeight: 700 }}>{item.name}</span>
                </div>
            ))}
        </div>
    </div>
}